/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  document.addEventListener("DOMContentLoaded", function() {
    const allBlocks = document.querySelectorAll('.product__block');
    let iconBlockIndex = 1;
    const iconBlocks = [];

    allBlocks.forEach((block) => {
      const hasIconRow = block.querySelector('.product__icon__row');
      if (hasIconRow) {
        block.classList.add('custom-product-icon-row');
        block.classList.add(`nth-${iconBlockIndex}`);
        iconBlocks.push(block);
        iconBlockIndex++;
      }
    });

    // Wrap consecutive icon blocks in a grid container so they render as a true grid
    // (avoids inline-block whitespace and baseline-alignment issues)
    if (iconBlocks.length > 0) {
      const groups = [];
      let currentGroup = [iconBlocks[0]];
      for (let i = 1; i < iconBlocks.length; i++) {
        if (iconBlocks[i].previousElementSibling === iconBlocks[i - 1]) {
          currentGroup.push(iconBlocks[i]);
        } else {
          groups.push(currentGroup);
          currentGroup = [iconBlocks[i]];
        }
      }
      groups.push(currentGroup);

      groups.forEach((group) => {
        if (group.length < 2) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'custom-product-icon-grid';
        group[0].parentNode.insertBefore(wrapper, group[0]);
        group.forEach((el) => wrapper.appendChild(el));
      });
    }
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
